<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else class="container">
        <div class="row">
          <div class="col-xs-6">
            <HelpText>
              <h3>
                Partnership Activity Mail
              </h3>

              <p>
                On this page, you can see the details of the partnership activity mail.
              </p>

              <button type="button" class="btn btn-black btn-sm" @click="send">
                <i class="fa fa-paper-plane"></i> Send
              </button>
            </HelpText>
          </div>

          <div class="col-xs-18">
            <div class="panel panel-default">
              <div class="panel-body">
                <iframe
                    v-if="content"
                    :srcdoc="content"
                    width="100%"
                    height="600px"
                    frameborder="0"
                />
              </div>
            </div>
          </div>
        </div>

        <hr class="panel-separator">

        <div class="row">
          <div class="col-xs-6">
            <HelpText>
              <h3>
                Recipients
              </h3>

              <p>
                This table displays the recipients of the mail.
              </p>

              <button
                  type="button"
                  class="btn btn-black btn-sm"
                  data-toggle="modal"
                  data-target="#create-partnership-activity-mail-recipient-modal"
              >
                <i class="fa fa-plus"></i> Create
              </button>
            </HelpText>
          </div>

          <div class="col-xs-18">
            <PartnershipActivityMailRecipientListPanel :partnership-activity-mail="partnershipActivityMail"/>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import http from '@/http'
import HelpText from '@/components/HelpText'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import HeadlineContainer from "../../../../../components/Layout/HeadlineContainer.vue";
import PartnershipActivityMailRecipientListPanel
  from "../../../../../components/Relations/PartnershipActivityMailRecipients/Panels/List.vue";
import modal from "@/modal";
import notify from "@/notify";

export default {
  components: {PartnershipActivityMailRecipientListPanel, HeadlineContainer, HelpText, LoadingContainer},

  props: ['partnershipActivityMailId'],

  data() {
    return {
      partnershipActivityMail: null,
      content: null,

      loading: true,
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      this.loading = true

      Promise.all([
        http.get('/api/v2/partnership-activity-mails/' + this.partnershipActivityMailId),
        http.get('/api/v2/partnership-activity-mails/' + this.partnershipActivityMailId + '/content')
      ])
          .then(responses => {
            this.partnershipActivityMail = responses[0].data.data
            this.content = responses[1].data

            this.loading = false
          })
    },

    send() {
      modal.confirm('Are your sure that you want to send the mail?', () => {
        http.post('/api/v2/partnership-activity-mails/' + this.partnershipActivityMail.id + '/send').then(() => {
          notify.success('The mail was sent')

          this.load()
        })
      })
    }
  }
}
</script>
